/**
 * Constants Used For Terms Of Use Component.
 */
export const TERMS_OF_USE_CONSTANTS = {
  TERMS_OF_USE_TEXT: 'Terms of Use',
  TERMS_OF_USE_URL: 'terms-of-use',
  TERMS_AND_CONDITIONS_TEXT: 'Terms and Conditions',
};
